module.exports = __webpack_public_path__ + "static/media/Data Asset Page Icons-05.97f6d1fc.svg";